import accuracyMap from 'helpers/presentation/accuracyMap'
import checkForInfinityOrNaN from 'helpers/presentation/checkForInfinityOrNaN'
import significantFigureCount from 'helpers/significantFigureCount'

/**
 * Loops over imported accuracy map, setting the properties and values of the new object. Along with rounding values to
 * pre-determined significant figures, it also takes into considersation the accruracy of the users input, reading/setting
 * the presentation value to be dirty or clean. It does not change the value that is being passed in.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Object} args.camera - Contains values that need to be rounded.
 * @param {Number} args.key - This is the value that is being changed in the calculator. Used to flag a no change in the loop.
 * @param {Object} args.value - The value of the input that is being updated, will be converted to a string.
 * @param {Object} args.prevPresentationValues - The value of the previous presentational values.
  * @param {Boolean} args.fromMap - If the value is being updated from the map.
 * @return {Object<string, string>}
 */



export default function calculatePresentationValues({ camera, key, value, prevPresentationValues, fromMap, skipRoundFocal }) {
  const newPresentationValues = {}

  for (let [attrName, accValue] of accuracyMap()) {
    const prevSigFigs = attrName === 'focalLength' && !skipRoundFocal ? accValue : significantFigureCount(prevPresentationValues[attrName].value)

    if (attrName === key) {
      if (fromMap) {
        newPresentationValues[attrName] = { value: `${Number(value).toFixed(prevSigFigs)}`, touched: true }
      } else {
        newPresentationValues[attrName] = { value: `${value}`, touched: true }
      }
      continue
    }

    const isOutlierValue = checkForInfinityOrNaN(camera[attrName])

    if (prevPresentationValues[attrName].touched) {
      const sigFigs = prevSigFigs === accValue ? accValue : prevSigFigs

      newPresentationValues[attrName] = {
        value: isOutlierValue ? '0' : camera[attrName].toFixed(sigFigs),
        touched: true
      }
    } else {
      newPresentationValues[attrName] = {
        value: isOutlierValue ? '0' : camera[attrName].toFixed(accValue),
        touched: false
      }
    }
  }

  return newPresentationValues
}



// WEBPACK FOOTER //
// ./src/helpers/presentation/roundPresentationValues.js